export default __webpack_public_path__ + "static/media/bannerRegistro_movil_3.25f127b8.jpg";